import { __stringify, exists, md5, MUSTNeverHappenException } from "@nu-art/ts-common";
export const composeDbObjectUniqueId = (item, keys) => {
    const _unique = keys.reduce((aggregatedValues, _key) => {
        if (!exists(item[_key]))
            throw new MUSTNeverHappenException(`Unique key missing from db item!\nkey: ${_key}\nitem:${__stringify(item, true)}`);
        return aggregatedValues + String(item[_key]);
    }, '');
    return md5(_unique);
};
//# sourceMappingURL=utils.js.map